import React, { useContext, useEffect, useState } from 'react';
import { List, ListHeader, DataColumn, LinkColumn } from 'components/lists';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { Config } from 'configs';
import { useNavigate } from 'react-router-dom';
import { PageTitle } from 'components/layouts/pageTitle';
import { PageContent } from 'components/layouts/pageContent';
import { ListLayout } from 'components/layouts/listLayout';
import { formatFullRestaurantAddress } from 'utils/renderingHelpers';

export const Restaurants = () => {
  const { state: auth } = useContext(AuthContext);
  const { state: companyState, deleteById, getCompanyRestaurants } = useContext(CompanyContext);
  const navigate = useNavigate();

  const [isLoadingInit, setIsLoadingInit] = useState(true);

  useEffect(() => {
    getCompanyRestaurants({ token: auth.token, companyId: auth.company?.company, refresh: true });
    setIsLoadingInit(false);
  }, []);

  const onEditClicked = (item) => {
    navigate(`/settings/restaurants/${item._id}`);
  };

  const onDeleteClicked = async (item) => {
    await deleteById(
      {
        collectionName: Config.DATA.COLLECTIONS.RESTAURANTS,
        token: auth.token,
        id: item._id,
        resourceV2: 'AdminRestaurant',
        companyIdForV2: auth.company?.company,
      },
      async () => {
        getCompanyRestaurants({ token: auth.token, companyId: auth.company?.company, refresh: true });
      },
    );
  };

  return (
    <ListLayout isLoading={companyState.isLoadingRestaurants || isLoadingInit}>
      <PageTitle title="Restaurants" breadcrumbs={[{ path: '/settings', title: 'Settings' }]} isTopLevel hideMobile />
      <PageContent>
        <ListHeader
          title="Restaurants"
          description={`Restaurants of ${auth.company?.display_name}`}
        >
          <button
            type="button"
            onClick={() => navigate('/settings/restaurants/add-new')}
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
          >
            Add new
          </button>
        </ListHeader>
        <List keyField="_id" source={companyState.restaurants} onRowClick={onEditClicked}>
          <DataColumn
            name="Name"
            dbColumnName="name"
            headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
            dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
          />
          <DataColumn
            name="Address"
            dbColumnName="address"
            render={(x) => formatFullRestaurantAddress(x)}
            headerClass="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
            dataCellClass="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
          />
          <DataColumn
            name="Phone"
            dbColumnName="phone"
            headerClass="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
            dataCellClass="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
          />
          <DataColumn
            name="Timezone"
            dbColumnName="zone"
            headerClass="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
            dataCellClass="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
          />
          <LinkColumn
            title="Delete"
            onClick={onDeleteClicked}
            askForConfirmation
            className="relative py-3.5 pl-3 sm:pr-6"
            dataCellClass="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
          />
        </List>
      </PageContent>
    </ListLayout>
  );
};
